import { Outlet } from 'react-router-dom'
import { Ship } from 'lucide-react'

const AuthLayout = () => {
  return (
    <div className="min-h-screen w-full flex bg-slate-50">
      {/* LEFT BRAND PANEL */}
      <aside className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage:
              'radial-gradient(circle at 20% 20%, rgba(59,130,246,0.4) 0, transparent 40%), radial-gradient(circle at 80% 70%, rgba(16,185,129,0.3) 0, transparent 35%)',
          }}
        ></div>
        <div className="relative z-10 flex flex-col justify-between p-10 xl:p-14 text-white w-full">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl bg-blue-500 flex items-center justify-center shadow-lg">
              <Ship className="w-5 h-5 text-white" />
            </div>
            <div className="text-lg font-bold tracking-tight">ShipsEdge</div>
          </div>
          <div className="space-y-5 max-w-md">
            <h1 className="text-3xl xl:text-4xl font-bold leading-tight text-white">
              Command your fleet with confidence.
            </h1>
            <p className="text-white/90 text-sm leading-relaxed">
              Real-time vessel tracking, planned maintenance, crew management and compliance —
              unified in one maritime operations platform.
            </p>
            {/* <div className="flex flex-wrap gap-2 pt-2">
              <span className="px-2.5 py-1 rounded-full bg-white/10 border border-white/15 text-[11px]">
                28 vessels
              </span>
              <span className="px-2.5 py-1 rounded-full bg-white/10 border border-white/15 text-[11px]">
                ISM & ISPS ready
              </span>
              <span className="px-2.5 py-1 rounded-full bg-white/10 border border-white/15 text-[11px]">
                SOC&nbsp;2 Type&nbsp;II
              </span>
            </div> */}
          </div>
          <p className="text-[11px] text-slate-400">
            © {new Date().getFullYear()} ShipsEdge. All rights reserved.
          </p>
        </div>
      </aside>

      {/* RIGHT FORM PANEL */}
      <main className="flex-1 flex items-center justify-center px-5 py-10 sm:px-10">
        <div className="w-full max-w-md">
          {/* Mobile-only logo */}
          <div className="lg:hidden flex items-center gap-2 mb-6">
            <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white">
              <Ship className="w-4 h-4 text-white" />
            </div>
            <span className="font-bold text-slate-900">ShipsEdge</span>
          </div>
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export { AuthLayout }
